<template>
  <div class="report-cover-wrapper visual side-visual report-visual" ref="reportVisual">
    <div class="report-cover-placer">
      <div class="report-cover" ref="reportCover">
        <div class="report-cover-inner" style="position: absolute; width: 100%; height: 100%">
          <div style="margin: 15% 10% 15% 10%">
            <img
              src="../../assets/sessions/characterscope-solo-title.png"
              :style="{ width: '100%', display: mode === 'solo' ? 'block' : 'none' }"
              alt="solo title"
            />
            <img
              src="../../assets/sessions/characterscope-viewpoints-title.png"
              :style="{ width: '80%', display: mode === 'viewpoints' ? 'block' : 'none' }"
              alt="viewpoints"
            />
            <div class="fake-horizontal-rule" v-if="mode === 'solo'" />
            <span style="font-size: 10px"
              >{{ subjectName }}

              <br />
              <span style="position: relative; top: -5px">
                <slot name="reportLeaderTypes"></slot>
              </span>
            </span>
            <div v-if="mode === 'solo'" style="font-size: 10px; margin-top: -5px">
              <div class="fake-horizontal-rule" />
              {{ reportDate ? reportDate : "" }}
            </div>
          </div>
          <div style="position: absolute; width: 50%; bottom: 2%; right: 2%" v-if="mode === 'solo'">
            <slot></slot>
          </div>
          <div
            style="width: 75%; margin: 0 auto; position: relative; top: -3%"
            v-if="mode === 'viewpoints'"
          >
            <slot></slot>
          </div>
          <img
            src="../../assets/brand/gyre-logo-full-pill.png"
            alt="Gyre logo"
            style="width: 100%; position: absolute; bottom: 6%; left: 10%; width: 40%"
            v-if="mode === 'viewpoints'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { TimelineMax } from "gsap";
import { computed, getCurrentInstance, ref } from "vue";

const props = defineProps<{
  subjectName?: string;
  reportDate?: string;
  mode?: "solo" | "viewpoints";
}>();

const instance = getCurrentInstance()?.proxy;
const session = instance?.$parent;

const subjectName = computed(() => props.subjectName ?? "SUBJECT NAME");
const reportDate = computed(() => props.reportDate ?? null);
const mode = computed(() => props.mode ?? "solo");

const reportVisual = ref<Element | null>(null);

const enter = (tl: TimelineMax): void => (session as any).zoomEnter(tl, reportVisual.value!);

const leave = (tl: TimelineMax): void => (session as any).zoomLeave(tl, reportVisual.value!);

defineExpose({ enter, leave });
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.report-visual {
  .report-cover {
    background-color: white;
    width: 100%;
    padding-bottom: 141.428%;
    position: relative;
    box-shadow: 0 0 20px #888;
  }

  .fake-horizontal-rule {
    width: 30%;
    height: 3px;
    margin-top: 5px;
    margin-bottom: 5px;
    background-color: rgb(109, 200, 191);
  }
}

.report-visual {
  .report-cover-placer {
    width: 55%;
    margin: 0 auto;
  }
}

.session.session-inline {
  .report-visual {
    .report-cover-placer {
      width: 80%;

      @media (orientation: landscape) {
        max-width: 50vh;
      }
    }
  }
}
</style>
